<template>
  <div>
    <as-dialogo
      ref="dialogoLogin"
      title="Entrar"
      max-width="600px"
      @onFechar="$refs.form.reset()"
    >
      <v-container fluid class="pa-2">
        <v-row dense>
          <v-col cols="12" lg="4" md="4" sm="4" style="text-align: center">
            <img
              src="img/namoda.svg"
              :style="$vuetify.breakpoint.smAndDown ? 'height: 96px' : ''"
            />
            <h5 class="mt-6">Não tem cadastro?</h5>
            <v-btn
              depressed
              small
              color="lightgray"
              class="text-white mt-2"
              @click="$refs.novoUsuario.abrir()"
              >Cadastre-se aqui</v-btn
            >
          </v-col>

          <v-col cols="12" lg="8" md="8" sm="8">
            <v-container fluid class="pa-2 pr-5 pb-0">
              <v-form v-model="formValid" ref="form" lazy-validation>
                <v-row>
                  <v-col
                    cols="12"
                    class="py-0"
                    :style="
                      $vuetify.breakpoint.smAndDown
                        ? 'display: none'
                        : 'text-align: right'
                    "
                  >
                    <label
                      @click="$refs.redefinirSenha.abrir()"
                      style="cursor: pointer"
                    >
                      <small>Esqueci a senha</small>
                    </label>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-text-field
                      label="Email"
                      ref="login"
                      v-model="user.email"
                      :rules="emailRules"
                      @keypress.native.enter="$refs.senha.focus()"
                      :autofocus="!user.email"
                      placeholder=" "
                      persistent-placeholder
                      autocomplete="off"
                      role="presentation"
                    ></v-text-field>

                    <v-text-field
                      label="Senha"
                      ref="senha"
                      type="password"
                      v-model="user.password"
                      :rules="passwordRules"
                      @keypress.native.enter="logar"
                      :autofocus="!!user.email"
                      placeholder=" "
                      persistent-placeholder
                      autocomplete="off"
                      role="presentation"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <p
                  style="color: red; text-align: right;"
                  class="px-3"
                  v-if="msgErro"
                >
                  {{ msgErro }}
                </p>
              </v-form>
              <v-row>
                <v-col style="display: flex; align-items: center">
                  <label style="margin-right: auto">
                    <small
                      @click="$refs.redefinirSenha.abrir()"
                      :style="
                        $vuetify.breakpoint.smAndDown
                          ? 'cursor: pointer'
                          : 'display: none'
                      "
                      >Esqueci a senha</small
                    >
                  </label>

                  <v-btn
                    depressed
                    color="primary"
                    :loading="logando"
                    :disabled="!formValid"
                    @click="logar"
                    class="white--text"
                    large
                    >Entrar</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </as-dialogo>

    <novo-usuario
      :cadastroCliente="cadastroCliente"
      ref="novoUsuario"
      @success="abrirDialogoCodigoValidacao"
    />

    <redefinir-senha
      ref="redefinirSenha"
      :email="user.email"
      @success="abrirDialogoCodigoValidacao"
    />

    <codigo-validacao
      ref="dialogoCodigoValidacao"
      :email="user.email"
      @success="abrirDialogoX"
    />

    <nova-senha ref="dialogoNovaSenha" :email="user.email" @success="logar" />
  </div>
</template>

<script>
import NovoUsuario from "@/views/login/NovoUsuario.vue";
import RedefinirSenha from "@/views/login/RedefinirSenha.vue";
import CodigoValidacao from "@/views/login/CodigoValidacao.vue";
import NovaSenha from "@/views/login/NovaSenha.vue";

import config from "@/config";
import ServicesUsers from "@/services/users.js";

export default {
  props: {
    email: {
      type: String,
      default: "",
    },
    onLoginOk: {
      type: Function,
    },
    cadastroCliente: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NovoUsuario,
    RedefinirSenha,
    CodigoValidacao,
    NovaSenha,
  },
  name: "Login",
  data() {
    return {
      formValid: true,
      logando: false,
      user: {
        email: this.email,
        password: "",
      },
      emailRules: [(v) => !!v || "O email é obrigatório"],
      passwordRules: [(v) => !!v || "A senha é obrigatória"],
      msgErro: "",
    };
  },
  methods: {
    abrirDialogoCodigoValidacao(params) {
      this.user.email = params.email;
      if (params.password) {
        this.user.password = params.password;
      }
      this.$refs.dialogoCodigoValidacao.abrir(params);
    },
    async abrirDialogoX(value) {
      if (value) {
        this.$refs.dialogoNovaSenha.abrir();
      } else {
        this.logar(this.user.password);
      }
    },
    async logar(value) {
      if (typeof value === "string") {
        this.user.password = value;
      }
      if (this.$refs.form.validate() || typeof value === "string") {
        try {
          this.logando = true;
          await ServicesUsers.login(this.user);
          this.onLoginOk();
          this.$refs.dialogoLogin.fechar();
          this.user.password = "";
          if (
            this.$router.currentRoute.name !== "loja" ||
            (!this.$auth.user.verificado &&
              this.$router.history.current.path !=
                "/" + this.$auth.user.tipo + "/minha-conta")
          ) {
            this.$router.push("/" + this.$auth.user.tipo + "/minha-conta");
          }
          if (this.cadastroCliente) {
            this.$router.push("/checkout");
          }
        } catch (error) {
          if (typeof error.response !== "undefined") {
            if (error.response.data.status == 2) {
              this.$eventbus.erro(error.response.data.message);
              this.abrirDialogoCodigoValidacao({
                email: this.user.email,
                password: this.user.password,
              });
            } else {
              this.msgErro = "Usuário ou senha inválidos";
              this.loginInvalido = true;
              setTimeout(() => {
                this.msgErro = "";
              }, 3000);
            }
          }
        }
        this.logando = false;
      }
    },
    abrir() {
      this.$refs.dialogoLogin.abrir();
      this.formValid = true;
    },
    fechar() {
      this.$refs.dialogoLogin.fechar();
    },
  },
  watch: {
    email: {
      handler: function(value) {
        this.user.email = value;
      },
    },
  },
};
</script>

<style></style>
